var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Linkedin Icon",
    d: "M23.7137 0.5H2.27952C1.29738 0.5 0.49939 1.30915 0.49939 2.30246V23.6975C0.49939 24.6908 1.29738 25.5 2.27952 25.5H23.7137C24.6958 25.5 25.4994 24.6908 25.4994 23.6975V2.30246C25.4994 1.30915 24.6958 0.5 23.7137 0.5ZM8.05519 21.9286H4.34984V9.99777H8.06077V21.9286H8.05519ZM6.20251 8.3683C5.0139 8.3683 4.05408 7.4029 4.05408 6.21987C4.05408 5.03683 5.0139 4.07143 6.20251 4.07143C7.38555 4.07143 8.35095 5.03683 8.35095 6.21987C8.35095 7.40848 7.39113 8.3683 6.20251 8.3683ZM21.9447 21.9286H18.2393V16.125C18.2393 14.7411 18.2114 12.9609 16.3141 12.9609C14.3833 12.9609 14.0876 14.4676 14.0876 16.0246V21.9286H10.3822V9.99777H13.9369V11.6272H13.9871C14.4838 10.6897 15.6947 9.70201 17.4972 9.70201C21.2472 9.70201 21.9447 12.1741 21.9447 15.3884V21.9286Z",
    fill: "#918E9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/LinkedinIcon.0913e3f759524a72473aea2d8bcc311e.svg";
export { ForwardRef as ReactComponent };